import axios from 'axios';

import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';
import { createActionType } from '../../utils/redux';
import {
  apiCreateTemplatePitch,
  apiGetTemplatePitches,
  apiUpdateTemplatePitch,
  apiCheckPitchQuality,
  apiCheckEmailSize,
  apiGetPitchCompletion,
} from '../../constants/apiRouting';

export const CREATE_PITCH_PENDING = 'CREATE_PITCH_PENDING';
export const CREATE_PITCH_FAIL = 'CREATE_PITCH_FAIL';
export const CREATE_PITCH_SUCCESS = 'CREATE_PITCH_SUCCESS';

export const UPDATE_PITCH_PENDING = 'UPDATE_PITCH_PENDING';
export const UPDATE_PITCH_FAIL = 'UPDATE_PITCH_FAIL';
export const UPDATE_PITCH_SUCCESS = 'UPDATE_PITCH_SUCCESS';

export const GET_PITCH_PENDING = 'GET_PITCH_PENDING';
export const GET_PITCH_FAIL = 'GET_PITCH_FAIL';
export const GET_PITCH_SUCCESS = 'GET_PITCH_SUCCESS';
export const GET_NEXT_PITCH_SUCCESS = 'GET_NEXT_PITCH_SUCCESS';

export const SENDING_PITCH_EMAIL_PENDING = 'SENDING_PITCH_EMAIL_PENDING';
export const SENDING_PITCH_EMAIL_FAIL = 'SENDING_PITCH_EMAIL_FAIL';
export const SENDING_PITCH_EMAIL_SUCCESS = 'SENDING_PITCH_EMAIL_SUCCESS';


export const GET_TEMPLATE_PITCH = createActionType('GET_TEMPLATE_PITCH');
export const CREATE_TEMPLATE_PITCH = createActionType('CREATE_TEMPLATE_PITCH');
export const UPDATE_TEMPLATE_PITCH = createActionType('UPDATE_TEMPLATE_PITCH');

export const GET_PITCH_QUALITY_METRICS = createActionType('GET_PITCH_QUALITY_METRICS');


export const createPitch = (params = {}) => async (dispatch) => {
  dispatch({
    type: CREATE_PITCH_PENDING,
    payload: {},
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/`,
      params, { withCredentials: true },
    );
    await dispatch({
      type: CREATE_PITCH_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_PITCH_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const createTemplatePitch = (params = {}) => async (dispatch) => {
  await dispatch({
    type: CREATE_TEMPLATE_PITCH.name,
    payload: axios.post(
      apiCreateTemplatePitch(),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const updateTemplatePitch = (pitchId, params = {}) => async (dispatch) => {
  await dispatch({
    type: UPDATE_TEMPLATE_PITCH.name,
    payload: axios.put(
      apiUpdateTemplatePitch(pitchId),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const getPitches = (params = {}, isInfiniteScroll = false) => async (dispatch) => {
  dispatch({
    type: GET_PITCH_PENDING,
    payload: {},
  });
  const fetchUrl = `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/`;

  try {
    const response = await axios.get(`${fetchUrl}`, { params, withCredentials: true });
    // eslint-disable-next-line no-unused-expressions
    isInfiniteScroll ? dispatch({
      type: GET_NEXT_PITCH_SUCCESS,
      payload: response.data,
    }) : dispatch({
      type: GET_PITCH_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_PITCH_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const getTemplatePitches = (params = {}) => async (dispatch) => {
  dispatch({
    type: GET_TEMPLATE_PITCH.pending,
    payload: {},
  });

  try {
    const response = await axios.get(apiGetTemplatePitches(), { params, withCredentials: true });
    // eslint-disable-next-line no-unused-expressions
    dispatch({
      type: GET_TEMPLATE_PITCH.success,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_TEMPLATE_PITCH.error,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const updatePitch = (pitchId, params = {}) => async (dispatch) => {
  dispatch({
    type: UPDATE_PITCH_PENDING,
    payload: {},
  });
  try {
    const response = await axios.patch(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/${pitchId}/`,
      params, { withCredentials: true },
    );
    dispatch({
      type: UPDATE_PITCH_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PITCH_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const sendPitchTestEmail = (pitchId, params = {
  email: null,
}) => async (dispatch) => {
  dispatch({
    type: SENDING_PITCH_EMAIL_PENDING,
    payload: {},
  });
  const fetchUrl = `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/${pitchId}/send_test_email/`;

  try {
    const response = await axios.post(`${fetchUrl}`, params, { withCredentials: true });
    dispatch({
      type: SENDING_PITCH_EMAIL_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: SENDING_PITCH_EMAIL_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const destroyPitch = pitchId => async (dispatch) => {
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}pitches/${pitchId}/`,
      { withCredentials: true },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const getPitchQualityMetrics = params => dispatch => (
  dispatch({
    type: GET_PITCH_QUALITY_METRICS.name,
    payload: axios.post(
      apiCheckPitchQuality(),
      params,
      { withCredentials: true },
    ).catch(err => handleErrors(err, dispatch)),
  })
);

export const getPitchCompletion = (pitchId, params) => async (dispatch) => {
  try {
    const response = await axios.post(
      apiGetPitchCompletion(),
      params,
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    return handleErrors(error, dispatch);
  }
};

export const getPitchSize = params => dispatch => (
  dispatch({
    type: GET_PITCH_QUALITY_METRICS.name,
    payload: axios.post(
      apiCheckEmailSize(),
      params,
      { withCredentials: true },
    ).catch(err => handleErrors(err, dispatch)),
  })
);

export const initializePitchQualityMetrics = () => dispatch => (
  dispatch({
    type: GET_PITCH_QUALITY_METRICS.success,
    payload: {
      data: {
        subject_length: 0,
        body_word_count: 0,
        question_count: 0,
        spam_word_count: 0,
        personalization: 0,
        email_size: 0,
      },
    },
  })
);
